export const BILLING_TYPES = {
  CREDIT_CARD: "Cartão de Crédito",
  PIX: "PIX",
  BOLETO: "Boleto Bancário",
};

export const BILLING_TYPE_OPTIONS = {
  creditCard: "CREDIT_CARD",
  pix: "PIX",
  boleto: "BOLETO",
};

export const BILLING_TYPE_OPTIONS_ARRAY = Object.keys(BILLING_TYPE_OPTIONS).map(
  key => [key, BILLING_TYPE_OPTIONS[key]],
);

export const translateBillingType = type => BILLING_TYPES?.[type];
